@if (listActivated) {
    <cl-dialogue
        [titleText]="'My placemarks'"
        [width]="500"
        [primaryButtonText]="'Create'"
        [primaryButtonDisabled]="!canSaveFromList()"
        (primaryButtonClicked)="savePlacemark(true)"
        [secondaryButtonText]="'Cancel'"
        (secondaryButtonClicked)="closeList()"
        (closed)="closeList()"
    >
        <div class="rel">
            @if (error) {
                <div class="alert alert-danger m20">{{ error }}</div>
            }
            <div class="list-container m20">
                @if ((!placemarks || placemarks.length === 0) && !filterText) {
                    <div>No placemarks found</div>
                }
                @if (placemarks?.length > 0 || filterText) {
                    <div class="form-label">Filter</div>
                    <div class="m10">
                        <input type="text" class="wide" [(ngModel)]="filterText" (ngModelChange)="filterList()" />
                    </div>
                    @if (placemarks.length === 0) {
                        <div>No placemarks. Change your filter</div>
                    }
                    @if (placemarks.length > 0) {
                        <table class="table">
                            <caption></caption>
                            <thead>
                                <tr>
                                    <th scope="col" class="title-col">Title</th>
                                    <th scope="col">Latitude</th>
                                    <th scope="col">Longitude</th>
                                    <th scope="col">Last edited</th>
                                    <th scope="col" class="icon-col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (placemark of placemarks; track placemark; let i = $index) {
                                    <tr>
                                        <td
                                            class="ellipsis link"
                                            [title]="placemark.name"
                                            (click)="zoom(placemark)"
                                            onkeypress=""
                                        >
                                            {{ placemark.name }}
                                        </td>
                                        <td>{{ placemark.latitude }}</td>
                                        <td>{{ placemark.longitude }}</td>
                                        <td>{{ placemark.updatedOn | date: 'yyyy-MM-dd' }}</td>
                                        <td>
                                            <span
                                                class="v-icon v-icon-edit link mr5"
                                                (click)="editPlacemark(placemark)"
                                                onkeypress=""
                                            ></span>
                                            <span
                                                class="v-icon v-icon-trash link"
                                                (click)="deletePlacemark(placemark.id)"
                                                onkeypress=""
                                            ></span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                }
            </div>
            <div class="m10">
                <strong>New placemark</strong>
            </div>
            <div class="flex-row">
                <div class="mr20">
                    <div class="form-label">Title</div>
                    <input type="text" [(ngModel)]="newName" />
                    <div class="val-error">&#160;</div>
                </div>
                <div class="mr20">
                    <div class="form-label">Latitude</div>
                    <input type="number" [(ngModel)]="newLatitude" (ngModelChange)="validate()" />
                    <div class="val-error">
                        @if (valError['new-latitude']) {
                            <span>{{ valError['new-latitude'] }}</span>
                        }
                        &#160;
                    </div>
                </div>
                <div class="mr20">
                    <div class="form-label">Longitude</div>
                    <input type="number" [(ngModel)]="newLongitude" (ngModelChange)="validate()" />
                    <div class="val-error">
                        @if (valError['new-longitude']) {
                            <span>{{ valError['new-longitude'] }}</span>
                        }
                        &#160;
                    </div>
                </div>
                <div class="v-icon v-icon-pin link" (click)="pinClicked()" onkeypress=""></div>
            </div>
            <cl-loader [isActive]="loading"></cl-loader>
        </div>
    </cl-dialogue>
}

@if (editDialogueActive) {
    <cl-dialogue
        [primaryButtonText]="mode === 'create' ? 'Save' : 'Update'"
        [primaryButtonDisabled]="!canSave()"
        (primaryButtonClicked)="mode === 'create' ? savePlacemark() : updatePlacemark()"
        [customButtons]="customButtons"
        (customButtonClicked)="customButtonClicked($event)"
        [titleText]="mode === 'create' ? 'New placemark' : 'Edit placemark'"
        [width]="460"
        (closed)="closeAll()"
    >
        <div class="rel">
            @if (error) {
                <div class="alert alert-danger m20">{{ error }}</div>
            }
            <div class="flex-row">
                <div class="mr20">
                    <div class="form-label">Title</div>
                    <input type="text" [(ngModel)]="editName" />
                    <div class="val-error">&#160;</div>
                </div>
                <div class="mr20">
                    <div class="form-label">Latitude</div>
                    <input type="number" [(ngModel)]="editLatitude" (ngModelChange)="validate()" />
                    <div class="val-error">
                        @if (valError['edit-latitude']) {
                            <span>{{ valError['edit-latitude'] }}</span>
                        }
                        &#160;
                    </div>
                </div>
                <div>
                    <div class="form-label">Longitude</div>
                    <input type="number" [(ngModel)]="editLongitude" (ngModelChange)="validate()" />
                    <div class="val-error">
                        @if (valError['edit-longitude']) {
                            <span>{{ valError['edit-longitude'] }}</span>
                        }
                        &#160;
                    </div>
                </div>
            </div>
            <cl-loader [isActive]="loading"></cl-loader>
        </div>
    </cl-dialogue>
}
